<div class="container">
  <div class="col-sm">
    <div class="row mt-4 mb-4">
      <div class="col-sm">
        <form [formGroup]="contactForm" (ngSubmit)="send(contactForm.value)" [hidden]="!hideForm">
          <div class="form-group row">
            <div class="col-sm mt-2">
              <input type="text" formControlName="firstName" class="form-control" id="firstName-id" placeholder="Votre Prénom *" i18n-placeholder="assistance|@@your_firstname">
              <div class="text-danger" *ngIf="!contactForm.controls['firstName'].valid && contactForm.controls['firstName'].touched">{{ firstNameErrorMessage }}</div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm mt-2">
              <input type="text" formControlName="entreprise" class="form-control" id="firstName-id" placeholder="Votre Entreprise *" i18n-placeholder="assistance|@@company">
              <div class="text-danger" *ngIf="!contactForm.controls['entreprise'].valid && contactForm.controls['entreprise'].touched">{{ entrepriseErrorMessage }}</div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm">
              <select formControlName="subject" class="form-control" id="subject-id">
                <option i18n="assistance|@@bug">Anomalies (bug)</option>
                <option i18n="assistance|@@new_idea">Nouvelle idée</option>
                <option i18n="assistance|@@other">Autre</option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm">
              <textarea formControlName="message" class="form-control" id="message-id" placeholder="Écrivez votre message *" i18n-placeholder="assistance|@@write_your_message"
                rows="8"></textarea>
              <div class="text-danger" *ngIf="!contactForm.controls['message'].valid && contactForm.controls['message'].touched">{{ messageErrorMessage }}</div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm">
              <small i18n="assistance|@@required_fields">* Les champs signalés par * sont obligatoires.</small>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm">
              <button type="submit" class="btn btn-info" i18n="assistance|@@send">Envoyer</button>
            </div>
          </div>
        </form>
        <div class="email-sent" [hidden]="hideForm">
          <div class="alert alert-success" role="alert">
            <h4 class="alert-heading" i18n="assistance|@@success">Succès</h4>
            <p i18n="assistance|@@message_sent">Votre message a été envoyé avec succès, notre équipe vous répondra le plus tôt possible.</p>
            <hr>
            <p class="mb-0" i18n="assistance|@@thank_you_for_your_interest">Merci pour l'intérêt que vous portez à Tchek.</p>
            <a class="btn btn-primary mt-4" [routerLink]="['/home']" i18n="assistance|@@go_home">Vers la page d'accueil</a>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <h3 class="contact-title" i18n="assistance|@@question_or_advice">Une question ou besoin d'un conseil ?</h3>
        <p class="lead mb-4" i18n="assistance|@@customer_service_available">
          Notre service client est disponible par téléphone. Vous pouvez également nous laisser un message via le formulaire de contact.
        </p>
        <p class="lead yellow mt-6 mb-6">
          <strong i18n="assistance|@@response_within_24_hours">Nous nous engageons à vous répondre sous 24h ouvrées.</strong>
          <a href="http://www.tchek.fr/" i18n="assistance|@@visit_website">Visiter le site Tchek</a>
        </p>
        <h4 class="mt-6" i18n="assistance|@@customer_service">Service client</h4>
        <p i18n="assistance|@@from_monday_to_friday">Du lundi au vendredi de 9h à 18h</p>
        <h4 class="yellow" i18n="assistance|@@customer_service_telephone">07 67 51 34 24</h4>
        <h6 class="yellow" i18n="assistance|@@customer_service_mail">contact@tchek.fr</h6>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>


// WEBPACK FOOTER //
// ./src/app/contact/contact.component.html